import { HelpCircle } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";

export const ScoreExplanationDialog = ({ baremeVersion }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button
        type="button"
        data-testid="bilan-score-explanation-link"
        className="inline-flex items-center gap-1.5 text-xs text-[#235277] underline underline-offset-2 hover:text-[#1E4767] transition-colors duration-150"
      >
        <HelpCircle className="w-3.5 h-3.5" aria-hidden="true" />
        Comment mon score est il calculé ?
      </button>
    </DialogTrigger>
    <DialogContent className="rounded-2xl max-w-[460px] bg-white">
      <DialogHeader>
        <DialogTitle className="font-heading text-lg text-[#060606]">Comment ton score est calculé</DialogTitle>
        <DialogDescription className="sr-only">Explication du calcul du score d'orientation CYCLIQ</DialogDescription>
      </DialogHeader>
      <div className="space-y-3 text-sm leading-relaxed text-[#333333]" data-testid="bilan-score-explanation-content">
        <p>
          Ton résultat est un <strong>repère interne</strong> construit à partir de tes
          réponses aux cinq dimensions CYCLIQ : compréhension et synchronisation, énergie,
          activité physique, nutrition et constance.
        </p>
        <p>
          Chaque dimension est calculée de 0 à 100 à partir de tes réponses, puis le score
          global combine ces dimensions selon des pondérations définies. Les questions
          laissées sans réponse, ou marquées je préfère ne pas répondre, sont simplement
          exclues du calcul : elles ne pénalisent jamais ton résultat.
        </p>
        <p>
          Le calcul est réalisé intégralement dans ton navigateur : tes réponses et tes
          scores ne sont jamais transmis ni conservés par CYCLIQ.
        </p>
        <p>
          Les scores CYCLIQ constituent des repères internes destinés à organiser tes
          réponses et à faciliter leur lecture. Ils ne constituent ni un diagnostic médical
          ni une évaluation clinique. Les pondérations sont des choix méthodologiques
          internes, jamais des seuils cliniques.
        </p>
        <p className="text-xs text-[#9E9E9E]" data-testid="bilan-bareme-version">
          Version du barème utilisée : {baremeVersion || "2.0.0"}
        </p>
      </div>
    </DialogContent>
  </Dialog>
);
